import { render, staticRenderFns } from "./MaterialCodeModal2.vue?vue&type=template&id=e450fd9e&scoped=true&"
import script from "./MaterialCodeModal2.vue?vue&type=script&lang=js&"
export * from "./MaterialCodeModal2.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCodeModal2.vue?vue&type=style&index=0&id=e450fd9e&prod&lang=scss&scoped=true&"
import style1 from "./MaterialCodeModal2.vue?vue&type=style&index=1&id=e450fd9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e450fd9e",
  null
  
)

export default component.exports